export default __webpack_public_path__ + "static/media/Neophyte's Hood of Secret Doors.47a449f5.jpg";